import React from "react";
import { Link } from "react-router-dom";
import "./RightElements.css";

const FooterElements = () => (
  <div className="footer-elements">
    <div className="footer-links-row">
      <a href="#">Despre</a>
      <Link to="/check-certification">Certificari</Link>
      <a href="#">Afiliere</a>
      <Link to="/blog">Blog</Link>
      <a href="#">Contact</a>
      <a href="#">Confidentialitate</a>
      <a href="#">Termeni</a>
    </div>
  </div>
);

export default FooterElements;
